var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("@keyframes rotate45 {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  25% {\n    transform: rotate(25deg);\n  }\n\n  75% {\n    transform: rotate(-25deg);\n  }\n\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n.rotating-element[data-v-f8458a6e] {\n  animation: rotate45 120s infinite;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _eventBus = require("../eventBus");

var _vue = require("vue");

var _toastifyJs = require("toastify-js");

var _toastifyJs2 = _interopRequireDefault(_toastifyJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "Ecitizen Wallet",
  props: {
    invoice: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    base_url: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      default: "KES"
    },
    callback_url: {
      type: String,
      required: true
    },
    notification_url: {
      type: String,
      required: true
    },
    wallet_token: {
      type: String,
      required: true,
      default: ""
    },
    wallet_merchant_id: {
      type: Number,
      required: true,
      default: ""
    }
  },
  data: function data() {
    return {
      accounts: [],
      currentAccount: null,
      showBalance: true,
      convertedBalance: null,
      isLoading: false,
      authToken: null,
      tpLength: [],
      otp: Array(6).fill(""),
      currentStep: 1,
      cooldownTime: 120,
      cooldownActive: false,
      cooldownTimer: null,
      customer_id: null,
      spotRates: {},
      msisdn: null,
      customer: null,
      email: null
    };
  },
  created: function created() {
    var _this = this;

    _eventBus.eventBus.$on("pay-invoice", function (currentAccount) {
      _this.sendOtp();
    });
  },
  mounted: async function mounted() {
    await this.getOrCreateWallet();

    if (this.accounts.length) {
      await this.switchAccount(this.currency);
    }
  },

  methods: {
    showToastr: function showToastr(type, title, subtitle) {
      var bgColor = void 0,
          icon = void 0;
      var color = "white";
      switch (type) {
        case "success":
          bgColor = "#4AC000";
          icon = "<svg viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.2499 10.5C19.2499 15.3325 15.3324 19.25 10.4999 19.25C5.66739 19.25 1.74988 15.3325 1.74988 10.5C1.74988 5.66751 5.66739 1.75 10.4999 1.75C15.3324 1.75 19.2499 5.66751 19.2499 10.5ZM14.0264 7.84846C14.2827 8.10474 14.2827 8.52026 14.0264 8.77654L9.65142 13.1515C9.39514 13.4078 8.97962 13.4078 8.72334 13.1515L6.97334 11.4015C6.71706 11.1453 6.71706 10.7297 6.97334 10.4735C7.22962 10.2172 7.64514 10.2172 7.90142 10.4735L9.18738 11.7594L11.1429 9.80394L13.0983 7.84846C13.3546 7.59218 13.7701 7.59218 14.0264 7.84846Z\" fill=\"white\"/>\n        </svg>";
          break;
        case "error":
          bgColor = "#E01A1A";
          icon = "<svg viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.2499 10.5C19.2499 5.66751 15.3324 1.75 10.4999 1.75C5.66739 1.75 1.74988 5.66751 1.74988 10.5C1.74988 15.3325 5.66739 19.25 10.4999 19.25C15.3324 19.25 19.2499 15.3325 19.2499 10.5ZM10.4999 5.46875C10.8623 5.46875 11.1561 5.76256 11.1561 6.125V11.375C11.1561 11.7374 10.8623 12.0313 10.4999 12.0313C10.1374 12.0313 9.84363 11.7374 9.84363 11.375V6.125C9.84363 5.76256 10.1374 5.46875 10.4999 5.46875ZM10.4999 14.875C10.9831 14.875 11.3749 14.4832 11.3749 14C11.3749 13.5168 10.9831 13.125 10.4999 13.125C10.0166 13.125 9.62488 13.5168 9.62488 14C9.62488 14.4832 10.0166 14.875 10.4999 14.875Z\" fill=\"white\"/>\n        </svg>";
          break;
        case "warning":
          bgColor = "#EF9300";
          icon = "<svg width=\"19\" height=\"19\" viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.2499 9.5C18.2499 14.3325 14.3324 18.25 9.49988 18.25C4.66739 18.25 0.749878 14.3325 0.749878 9.5C0.749878 4.66751 4.66739 0.75 9.49988 0.75C14.3324 0.75 18.2499 4.66751 18.2499 9.5ZM13.0264 6.84846C13.2827 7.10474 13.2827 7.52026 13.0264 7.77654L8.65142 12.1515C8.39514 12.4078 7.97962 12.4078 7.72334 12.1515L5.97334 10.4015C5.71706 10.1453 5.71706 9.72974 5.97334 9.47346C6.22962 9.21718 6.64514 9.21718 6.90142 9.47346L8.18738 10.7594L10.1429 8.80394L12.0983 6.84846C12.3546 6.59218 12.7701 6.59218 13.0264 6.84846Z\" fill=\"white\"/>\n        </svg>";
          break;
        case "info":
        default:
          bgColor = "#D6D6D6";
          icon = "<svg viewBox=\"0 0 21 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.2499 10.5C19.2499 15.3325 15.3324 19.25 10.4999 19.25C5.66739 19.25 1.74988 15.3325 1.74988 10.5C1.74988 5.66751 5.66739 1.75 10.4999 1.75C15.3324 1.75 19.2499 5.66751 19.2499 10.5ZM10.4999 15.5313C10.8623 15.5313 11.1561 15.2374 11.1561 14.875V9.625C11.1561 9.26256 10.8623 8.96875 10.4999 8.96875C10.1374 8.96875 9.84363 9.26256 9.84363 9.625V14.875C9.84363 15.2374 10.1374 15.5313 10.4999 15.5313ZM10.4999 6.125C10.9831 6.125 11.3749 6.51675 11.3749 7C11.3749 7.48325 10.9831 7.875 10.4999 7.875C10.0166 7.875 9.62488 7.48325 9.62488 7C9.62488 6.51675 10.0166 6.125 10.4999 6.125Z\" fill=\"black\"/>\n        </svg>";
          color = "black";
      }

      var dynamicDiv = document.createElement("div");
      dynamicDiv.innerHTML = "\n      <div class=\"flex items-center gap-2.5\">\n        <div class=\"p-2.5 bg-white/25 rounded-full flex items-center justify-center\">\n          <div class=\"w-6 h-6 flex items-center justify-center overflow-hidden\">" + icon + "</div>\n        </div>\n        <div class=\"flex flex-col gap-2.5\">\n          <p class=\"text-" + color + " text-sm font-medium\">" + title + "</p>\n          <p class=\"text-" + color + " text-xs font-normal\">" + subtitle + "</p>\n        </div>\n      </div>\n    ";

      (0, _toastifyJs2.default)({
        node: dynamicDiv,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        stopOnFocus: true,
        style: {
          background: bgColor,
          width: "328px",
          display: "flex",
          alignItems: "start",
          justifyContent: "space-between",
          color: color
        }
      }).showToast();
    },
    initiatePayment: function initiatePayment() {
      var _this2 = this;

      var otpString = this.otp.filter(function (code) {
        return code !== "";
      }).join("");

      var payload = {
        invoice_number: this.invoice.invoice_number,
        otp: otpString,
        pesaflow_account_id: this.currentAccount.id,
        msisdn: this.sanitizePhoneNumber(this.customer.msisdn),
        amount: this.invoice.amount_expected
      };
      var init_pay_url = this.base_url + "/api/customer/co/make/payment";
      this.isLoading = true;
      Vue.axios.post(init_pay_url, payload).then(function (response) {
        if (response.statusText == "OK") {
          window.top.location.href = _this2.callback_url;
        } else {
          _this2.error_message = response.data.message;
          _this2.showToastr('error', 'Error', "" + _this2.error_message);
        }
      }).catch(function (error) {
        _this2.error_message = "An error occurred. Try again later!";
        _this2.showToastr('error', 'Error', 'An error occurred. Try again later!');
      }).finally(function () {
        _this2.isLoading = false;
      });
    },
    maskPhone: function maskPhone(phone) {
      if (!phone) return "";

      var cleaned = phone.replace(/\D/g, "");
      if (cleaned.startsWith("254")) {
        cleaned = "0" + cleaned.slice(3);
      }

      if (cleaned.length !== 10) return phone;

      return cleaned.slice(0, 2) + " *** *** " + cleaned.slice(-3);
    },
    sanitizePhoneNumber: function sanitizePhoneNumber(phoneNumber) {
      if (!phoneNumber) return '';

      var cleaned = phoneNumber.replace(/[\s+]/g, '');

      if (cleaned.startsWith('0')) {
        return cleaned.replace(/^0/, '254');
      } else {
        return cleaned;
      }
    },
    sendOtp: function sendOtp() {
      var _this3 = this;

      if (!this.customer.email && !this.customer.msisdn) {
        this.showToastr('error', 'Error', 'Phone number or email is missing');
        return;
      }

      var otp_url = this.base_url + "/api/customer/otp/request";
      var payload = {
        customer_id: this.customer_id
      };
      this.isLoading = true;
      Vue.axios.post(otp_url, payload).then(function (response) {
        _this3.currentStep = 2;
        _this3.startCooldown();
        _this3.showToastr('success', 'Success', "We have sent an OTP to " + _this3.computeMasked(_this3.customer, false));
      }).catch(function (error) {
        _this3.error_message = "An error occurred. Try again later!";
        _this3.showToastr('error', 'Error', 'An error occurred. Try again later!');
      }).finally(function () {
        _this3.isLoading = false;
      });
    },
    startCooldown: function startCooldown() {
      var _this4 = this;

      this.cooldownActive = true;
      this.cooldownTime = 120;
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer);
      }

      this.cooldownTimer = setInterval(function () {
        if (_this4.cooldownTime <= 0) {
          _this4.stopCooldown();
        } else {
          _this4.cooldownTime--;
        }
      }, 1000);
    },
    stopCooldown: function stopCooldown() {
      this.cooldownActive = false;
      this.cooldownTime = 120;
      if (this.cooldownTimer) {
        clearInterval(this.cooldownTimer);
        this.cooldownTimer = null;
      }
    },
    topupWallet: function topupWallet() {
      _eventBus.eventBus.$emit("topup-wallet-clicked", this.currentAccount, this.base_url, this.customer_id, true);
    },
    switchAccount: async function switchAccount(currency) {
      this.isLoading = true;
      if (!this.accounts || !this.accounts.length) return;

      this.currentAccount = this.accounts.find(function (account) {
        return account.currency === currency;
      });
      await this.updateConvertedBalance();
      this.isLoading = false;
      this.selectWallet();
    },
    selectWallet: async function selectWallet() {
      this.performCurrencyConversion(this.invoice, this.currentAccount);
      _eventBus.eventBus.$emit("wallet-selected", this.currentAccount, this.notification_url, this.base_url, this.customer_id, this.spotRates, this.invoice);
    },
    maskPhoneNumber: function maskPhoneNumber(tel) {
      return tel.replace(/(\d{4})\d+(\d{3})/, "$1******$2");
    },
    maskEmail: function maskEmail(email) {
      var _email$split = email.split("@"),
          _email$split2 = (0, _slicedToArray3.default)(_email$split, 2),
          username = _email$split2[0],
          domain = _email$split2[1];

      return username[0] + "*****@" + domain[0] + "*****." + domain.split(".").pop();
    },
    determine_id_type: function determine_id_type(invoice) {
      if (invoice.billing_address_country_code && invoice.billing_address_country_code.toLowerCase == "ke") {
        return "citizen";
      } else {
        return "foreigner";
      }
    },
    computeMasked: function computeMasked(customer, html) {
      if (html) {
        if (this.customer.email && this.customer.msisdn) {
          return "your phone <span class=\"font-semibold\">" + this.maskPhone(this.customer.msisdn) + "</span> or email <span class=\"font-semibold\">" + this.maskEmail(this.customer.email) + "</span>";
        } else if (this.customer.email) {
          return "your email <span class=\"font-semibold\">" + this.maskEmail(this.customer.email) + "</span>";
        } else {
          return "your phone <span class=\"font-semibold\">" + this.maskPhone(this.customer.msisdn) + "</span>";
        }
      } else {
        if (this.customer.email && this.customer.msisdn) {
          return "your phone " + this.maskPhoneNumber(this.customer.msisdn) + " or email " + this.maskEmail(this.customer.email);
        } else if (this.customer.email) {
          return "your email " + this.maskEmail(this.customer.email);
        } else {
          return "your phone " + this.maskPhoneNumber(this.customer.msisdn);
        }
      }
    },
    topupAndPay: function topupAndPay() {
      _eventBus.eventBus.$emit("topup-and-pay-wallet-clicked", this.currentAccount, this.notification_url, this.customer_id, this.base_url, true);
    },
    updateConvertedBalance: async function updateConvertedBalance() {
      if (!this.currentAccount || !this.invoice) return;

      try {
        if (this.currentAccount.currency !== this.invoice.currency) {
          var rates = await this.getSpotRate(this.currentAccount.currency, this.invoice.currency);

          if (rates) {
            if (this.currentAccount.currency == "USD" && this.invoice.currency == "KES") {
              this.convertedBalance = parseFloat((this.invoice.amount_expected / parseFloat(this.spotRates.sell)).toFixed(2));
            } else {
                this.convertedBalance = parseFloat((this.invoice.amount_expected / parseFloat(this.spotRates.buy)).toFixed(2));
              }
          }
        } else {
          this.convertedBalance = parseFloat(this.invoice.amount_expected);
        }
      } catch (error) {
        this.showToastr('error', 'Error', 'Something happened. Please try again later!');
      }
    },
    getSpotRate: async function getSpotRate(base_currency, quote_currency) {
      this.isLoading = true;
      try {
        var response = await Vue.axios.get(this.base_url + "/api/conversion/rates", {
          params: { base_currency: base_currency, quote_currency: quote_currency }
        });
        return this.spotRates = response.data;
      } catch (error) {
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
    getOrCreateWallet: async function getOrCreateWallet() {
      var _this5 = this;

      this.isLoading = true;
      var id_type = this.determine_id_type(this.invoice);

      try {
        var response = await Vue.axios.post(this.base_url + "/api/custom/registration", {
          id_type: id_type,
          id_number: this.invoice.id_number,
          msisdn: this.invoice.msisdn,
          email: this.invoice.email,
          name: this.invoice.name,
          parent_id: parseInt(this.wallet_merchant_id)
        }, {
          headers: {
            Authorization: "Bearer " + this.wallet_token,
            "Content-Type": "application/json"
          }
        }).then(function (response) {
          _this5.accounts = response.data.accounts.sort(function (a, b) {
            if (a.currency === "KES") return -1;
            if (b.currency === "KES") return 1;
            return 0;
          });
          _this5.customer_id = response.data.id;
          _this5.msisdn = response.data.msisdn;
          _this5.email = response.data.email;
          _this5.customer = response.data;
        });
      } catch (error) {
        var _response = error.response;
        this.accounts = _response.data.accounts.sort(function (a, b) {
          if (a.currency === "KES") return -1;
          if (b.currency === "KES") return 1;
          return 0;
        });
        this.customer_id = _response.data.id;
        this.msisdn = _response.data.msisdn;
        this.email = _response.data.email;
        this.customer = _response.data;
      } finally {
        this.isLoading = false;
      }
    },
    handleInput: function handleInput(index) {
      this.otp[index] = this.otp[index].toUpperCase();
      if (this.otp[index].length === 1 && index < this.otp.length - 1) {
        this.$refs["otp" + (index + 1)][0].focus();
      }
    },
    handleBackspace: function handleBackspace(index) {
      if (this.otp[index].length === 0 && index > 0) {
        this.$refs["otp" + (index - 1)][0].focus();
      }
    },
    handlePaste: function handlePaste(event) {
      var _this6 = this;

      event.preventDefault();

      var pasteData = event.clipboardData.getData("text").toUpperCase();
      var pasteArray = pasteData.split("").slice(0, 6);
      pasteArray.forEach(function (char, index) {
        if (/[A-Za-z0-9]/.test(char)) {
          _this6.otp[index] = char;
        }
      });

      var lastFilledIndex = pasteArray.length - 1;
      if (lastFilledIndex < this.otp.length) {
        this.$refs["otp" + lastFilledIndex][0].focus();
      }
    },
    notifyOtherComponents: function notifyOtherComponents() {
      this.currentStep--;
      _eventBus.eventBus.$emit("refresh-component-actions", false);
    },
    performCurrencyConversion: function performCurrencyConversion(invoice, currentAccount) {
      var _this7 = this;

      Vue.axios.post('/api/invoice/currency/conversion', { invoice_number: invoice.invoice_number, client_ref_no: invoice.client_invoice_ref, convert_to_currency: currentAccount.currency }).then(function (response) {
        if (response.status === 200) {
          _this7.refreshPage(response.data.path);
        } else {}
      }).catch(function (error) {
        console.error('Error performing currency conversion');
        _this7.showToastr("warning", 'Error', "Please select wallet again.");
      });
    },
    refreshPage: function refreshPage(path) {
      if (window.localStorage && !window.localStorage.getItem('reload')) {
        window.localStorage.setItem('reload', true);
        window.location.reload();
      } else {
        localStorage.removeItem('reload');
      }
    }
  },
  computed: {
    displayCurrency: function displayCurrency() {
      return this.currentAccount ? this.currentAccount.currency : this.currency;
    },
    displayBalance: function displayBalance() {
      return this.currentAccount ? this.currentAccount.balance : 0;
    },
    shouldShowTopUpPay: function shouldShowTopUpPay() {
      if (this.isLoading) return false;
      if (!this.currentAccount || !this.invoice) return true;
      if (this.convertedBalance === null) return true;
      return parseFloat(this.currentAccount.balance.replace(/,/g, "")) < parseFloat(this.convertedBalance);
    },
    shouldShowPayInvoice: function shouldShowPayInvoice() {
      if (this.isLoading) return false;
      if (!this.currentAccount || !this.invoice) return false;
      if (this.convertedBalance === null) return false;
      return parseFloat(this.currentAccount.balance.replace(/,/g, "")) >= parseFloat(this.convertedBalance);
    },
    formattedCooldownTime: function formattedCooldownTime() {
      var minutes = Math.floor(this.cooldownTime / 60);
      var seconds = this.cooldownTime % 60;
      return minutes + ":" + seconds.toString().padStart(2, "0");
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (this.cooldownTimer) {
      clearInterval(this.cooldownTimer);
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.currentStep == 1)?_c('div',{staticClass:"col-span-10 h-full mt-4 flex flex-col gap-6"},[(_vm.shouldShowPayInvoice)?_c('button',{staticClass:"lg:hidden flex gap-2 bg-white hover:bg-gray-100 !bg-[#0054A6] rounded-md px-5 py-2 text-sm font-medium text-white items-center justify-center",on:{"click":_vm.sendOtp}},[_vm._v("\n      Pay\n      "),_c('svg',{staticClass:"size-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"}})])]):_vm._e(),_vm._v(" "),(_vm.shouldShowTopUpPay)?_c('button',{staticClass:"lg:hidden flex gap-2 bg-white hover:bg-gray-100 !bg-[#0054A6] rounded-md px-5 py-2 text-sm font-medium text-white items-center justify-center",on:{"click":_vm.topupAndPay}},[_vm._v("\n      Pay\n      "),_c('svg',{staticClass:"size-4",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-col border-t border-t-[#D6DEFF] pt-4 sm:flex-col gap-6 w-full sm:items-start justify-between"},[_c('h4',{staticClass:"text-black text-sm font-medium leading-snug tracking-tight"},[_vm._v("\n        Pay using eCitizen Wallet\n      ")]),_vm._v(" "),(_vm.currentAccount)?_c('div',{staticClass:"flex gap-3 w-full items-center"},[_c('div',{staticClass:"flex bg-[#F0F0EF] sm:ml-auto w-full sm:w-fit rounded-[50px]"},[_c('button',{staticClass:"py-[6px] px-5 w-full sm:w-fit rounded-[50px] text-sm",class:{
              'bg-[#0054A6] text-white font-bold': _vm.displayCurrency === 'KES',
              'bg-transparent text-black font-semibold':
                _vm.displayCurrency !== 'KES',
            },attrs:{"type":"button"},on:{"click":function($event){return _vm.switchAccount('KES')}}},[_c('span',[_vm._v("KES Wallet")])]),_vm._v(" "),_c('button',{staticClass:"py-[6px] px-5 w-full sm:w-fit rounded-[50px] text-sm",class:{
              'bg-[#0054A6] text-white font-bold': _vm.displayCurrency === 'USD',
              'bg-transparent text-black font-semibold':
                _vm.displayCurrency !== 'USD',
            },attrs:{"type":"button"},on:{"click":function($event){return _vm.switchAccount('USD')}}},[_c('span',[_vm._v("USD Wallet")])])])]):_vm._e()]),_vm._v(" "),(_vm.accounts.length > 0 && _vm.currentAccount)?_c('div',{staticClass:"grid grid-cols-1 md:grid-cols-2 gap-2"},_vm._l((_vm.accounts),function(acc,index){return _c('button',{key:index,staticClass:"py-8 px-7 bg-no-repeat bg-center bg-cover flex flex-col-reverse sm:flex-row gap-4 w-full justify-between rounded-[16px] relative overflow-hidden duration-[200ms] scale-90",class:{ 'border-[6px] border-[96C4FF] text-white': acc.currency == _vm.currentAccount.currency, 'hidden md:flex': acc.currency !== _vm.currentAccount.currency },style:(("background: " + (acc.currency == _vm.currentAccount.currency
          ? 'linear-gradient(177deg, #2F78D6 -42.03%, #0054A6 82.4%)'
          : '#F2F2F2') + "; box-shadow: " + (acc.currency == _vm.currentAccount.currency
          ? '0px 0px 13.4px 0px rgba(0, 111, 255, 0.38)'
          : 'none') + ";")),on:{"click":function($event){return _vm.switchAccount(acc.currency)}}},[_c('div',{class:[
          'absolute right-6 bottom-[-157px] bg-[60%] bg-right bg-no-repeat z-0 h-[454px] w-[454px] rotating-element' ],staticStyle:{"background-image":"url('/iframev2/assets/img/png/image.png')"}}),_vm._v(" "),_c('div',{staticClass:"flex flex-col gap-[14px] flex-1 justify-between h-full w-full"},[_c('div',{staticClass:"flex gap-4 justify-between"},[(_vm.isLoading)?_c('div',{staticClass:"flex items-center justify-center"},[_c('div',{staticClass:"animate-pulse bg-white/50 rounded-md px-5 py-2"},[_vm._v("\n                Loading...\n              ")])]):[_c('div',{staticClass:"flex flex-col gap-[14px] relative z-[1] text-left"},[_c('h3',{staticClass:"text-sm font-normal font-['Inter'] leading-tight tracking-[2.66px]"},[_vm._v("\n                  "+_vm._s(acc.currency)+" WALLET BAL.\n                ")]),_vm._v(" "),_c('p',{staticClass:"text-2xl font-semibold font-['Inter'] leading-tight duration-[100ms]",class:{ blur: !_vm.showBalance }},[_vm._v("\n                  "+_vm._s(acc.currency)+" "+_vm._s(acc.balance)+"\n                ")])])],_vm._v(" "),_c('div',{staticClass:"flex ml-auto gap-7 items-start relative z-[1]"},[_c('button',{staticClass:"cursor-pointer duration-0",on:{"click":function($event){$event.stopPropagation();_vm.showBalance = !_vm.showBalance}}},[(!_vm.showBalance)?_c('svg',{staticClass:"size-6",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"}}),_vm._v(" "),_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"}})]):_c('svg',{staticClass:"size-6",attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","stroke-width":"1.5","stroke":"currentColor"}},[_c('path',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round","d":"M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"}})])])])],2),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-end"},[(acc.currency == _vm.currentAccount.currency)?_c('svg',{attrs:{"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"1.00787","width":"19","height":"19","rx":"9.5","fill":"white"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0.5","y":"1.00787","width":"19","height":"19","rx":"9.5","stroke":"white"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14.6663 7.00787L8.24967 13.4245L5.33301 10.5079","stroke":"#006FFF","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})]):_c('svg',{attrs:{"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.875","y":"0.632874","width":"19","height":"19","rx":"9.5","fill":"white"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0.875","y":"0.632874","width":"19","height":"19","rx":"9.5","stroke":"#D0D5DD"}})])])])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hidden flex flex-col items-center py-6 gap-4"},[_c('svg',{attrs:{"width":"130","height":"131","viewBox":"0 0 130 131","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_2885_39976)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M65 110.866C89.8528 110.866 110 90.7191 110 65.8663C110 41.0135 89.8528 20.8663 65 20.8663C53.8498 20.8663 49.6114 34.2401 41.75 40.9564C32.0891 49.21 20 52.1637 20 65.8663C20 90.7191 40.1472 110.866 65 110.866Z","fill":"#EEF0F6"}}),_vm._v(" "),_c('g',{attrs:{"filter":"url(#filter0_f_2885_39976)"}},[_c('path',{attrs:{"d":"M89 50.8663H50C48.7574 50.8663 47.75 51.7276 47.75 52.7902V93.1924C47.75 94.2549 48.7574 95.1163 50 95.1163H89C90.2426 95.1163 91.25 94.2549 91.25 93.1924V52.7902C91.25 51.7276 90.2426 50.8663 89 50.8663Z","fill":"white"}}),_vm._v(" "),_c('path',{attrs:{"d":"M89 50.8663H50C48.7574 50.8663 47.75 51.7276 47.75 52.7902V93.1924C47.75 94.2549 48.7574 95.1163 50 95.1163H89C90.2426 95.1163 91.25 94.2549 91.25 93.1924V52.7902C91.25 51.7276 90.2426 50.8663 89 50.8663Z","fill":"#E1E5EF","fill-opacity":"0.5"}})]),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M83.4957 86.7676C84.2697 86.0797 84.3394 84.8945 83.6514 84.1206L77.6514 77.3706C76.9634 76.5966 75.7783 76.5269 75.0043 77.2149C74.2304 77.9028 74.1607 79.088 74.8486 79.8619L80.8486 86.6119C81.5366 87.3859 82.7217 87.4556 83.4957 86.7676Z","fill":"#CDCFE0","fill-opacity":"0.5"}}),_vm._v(" "),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M69.5 61.7413C65.1508 61.7413 61.625 65.267 61.625 69.6163C61.625 73.9655 65.1508 77.4913 69.5 77.4913C73.8492 77.4913 77.375 73.9655 77.375 69.6163C77.375 65.267 73.8492 61.7413 69.5 61.7413ZM57.875 69.6163C57.875 63.196 63.0797 57.9913 69.5 57.9913C75.9203 57.9913 81.125 63.196 81.125 69.6163C81.125 76.0366 75.9203 81.2413 69.5 81.2413C63.0797 81.2413 57.875 76.0366 57.875 69.6163Z","fill":"#CDCFE0","fill-opacity":"0.5"}})]),_vm._v(" "),_c('defs',[_c('filter',{attrs:{"id":"filter0_f_2885_39976","x":"31.25","y":"34.3663","width":"76.5","height":"77.25","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_vm._v(" "),_c('feBlend',{attrs:{"mode":"normal","in":"SourceGraphic","in2":"BackgroundImageFix","result":"shape"}}),_vm._v(" "),_c('feGaussianBlur',{attrs:{"stdDeviation":"8.25","result":"effect1_foregroundBlur_2885_39976"}})],1),_vm._v(" "),_c('clipPath',{attrs:{"id":"clip0_2885_39976"}},[_c('rect',{attrs:{"width":"90","height":"90","fill":"white","transform":"translate(20 20.8663)"}})])])]),_vm._v(" "),_c('p',{staticClass:"text-[#78838d] text-xs font-normal"},[_vm._v("\n        No transactions History.\n      ")])])]):_vm._e(),_vm._v(" "),(_vm.currentStep == 2)?_c('section',{staticClass:"col-span-10 h-full mt-4"},[_c('div',{staticClass:"mb-8"},[_c('nav',{staticClass:"flex",attrs:{"aria-label":"Breadcrumb"}},[_c('ol',{staticClass:"flex items-center gap-4",attrs:{"role":"list"}},[_c('li',[_c('div',{staticClass:"flex items-center"},[_c('a',{staticClass:"text-sm font-medium text-gray-500 hover:text-primary-100",attrs:{"href":"#"},on:{"click":function($event){_vm.currentStep--}}},[_vm._v("Make\n                payment")])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"flex items-center"},[_c('svg',{staticClass:"h-5 w-5 flex-shrink-0 text-gray-400",attrs:{"viewBox":"0 0 20 20","fill":"currentColor","aria-hidden":"true","data-slot":"icon"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z","clip-rule":"evenodd"}})]),_vm._v(" "),_c('a',{staticClass:"ml-4 text-sm font-semibold text-[#0054A6] hover:text-blue-500",attrs:{"href":"#","aria-current":"page"}},[_vm._v("Verification")])])])])])]),_vm._v(" "),_c('div',[_c('h6',{staticClass:"text-[#344054] font-medium text-sm mb-5"},[_vm._v("Verification")]),_vm._v(" "),_c('p',{staticClass:"mb-1.5"},[_vm._v("\n        We have sent an OTP to "),_c('span',{domProps:{"innerHTML":_vm._s(this.computeMasked(this.customer, true))}})]),_vm._v(" "),_c('h6',{staticClass:"text-[#344054] font-medium text-sm mb-1.5"},[_vm._v("Secure code")]),_vm._v(" "),_c('div',{staticClass:"mb-7"},[_c('div',{staticClass:"flex items-center gap-2"},_vm._l((_vm.otp),function(value,index){return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.otp[index]),expression:"otp[index]"}],key:index,ref:'otp' + index,refInFor:true,staticClass:"w-12 border border-[#D0D5DD] rounded-lg text-center text-[24px] text-[#000] tracking-[-2%] font-medium leading-[60px] pb-[3px] placeholder:text-[#D0D5DD]",attrs:{"placeholder":"*","maxlength":"1","pattern":"[A-Za-z0-9]*","inputmode":"text","autocapitalize":"on"},domProps:{"value":(_vm.otp[index])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.otp, index, $event.target.value)},function($event){return _vm.handleInput(index)}],"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"backspace",undefined,$event.key,undefined)){ return null; }return _vm.handleBackspace(index)},"paste":_vm.handlePaste}})}),0)]),_vm._v(" "),_c('div',{staticClass:"mb-10 sm:mb-20"},[_c('p',{staticClass:"text-sm font-medium text-[#344054]"},[_vm._v("\n          Did not get OTP\n          "),_c('button',{staticClass:"text-[#006FFF] text-sm font-semibold",class:{ 'opacity-50 cursor-not-allowed': _vm.cooldownActive },attrs:{"disabled":_vm.cooldownActive},on:{"click":_vm.sendOtp}},[_vm._v("\n            "+_vm._s(_vm.cooldownActive
                ? ("Resend OTP in (" + _vm.formattedCooldownTime + ")")
                : "Resend")+"\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"flex items-center gap-3"},[_c('button',{staticClass:"w-full text-center btn-outline",on:{"click":_vm.notifyOtherComponents}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('button',{staticClass:"w-full text-center btn-primary",on:{"click":_vm.initiatePayment}},[_vm._v("Next")])])])]):_vm._e()])}
__vue__options__.staticRenderFns = []
__vue__options__._scopeId = "data-v-f8458a6e"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f8458a6e", __vue__options__)
  } else {
    hotAPI.reload("data-v-f8458a6e", __vue__options__)
  }
})()}